import PropTypes from 'prop-types'
import { TextInput, Checkbox } from 'carbon-components-react'
import { LiveAnnouncer, LiveMessage } from 'react-aria-live'

export const TextInputType = 'textInput' 
export const CheckboxType = 'checkbox' 
export const PasswordType = 'password' 
export default function FormInput( props ) {
    const { ariaLabel, visible, inputType, labelText, checkboxLabelText, inputWrapperClassName, ...inputProps } = props
    const { invalid, invalidText,  } = props
    return (
        <>
            { visible && (
                <div className={ `c-form-item-custom-padding-bottom ${ inputWrapperClassName ? inputWrapperClassName : '' }` }>
                    { inputType === TextInputType &&
                        <TextInput 
                            { ...inputProps }
                            labelText={ labelText }
                            aria-label={ ariaLabel }
                        />                        
                    } 
                    { inputType === CheckboxType &&
                        <Checkbox 
                            { ...inputProps }
                            aria-label={ ariaLabel }
                            labelText={ checkboxLabelText }
                        />
                    }
                    { inputType === PasswordType &&
                        <TextInput.PasswordInput 
                            { ...inputProps }
                            aria-label={ ariaLabel }
                            labelText={ labelText }
                        />
                    }
                    <LiveAnnouncer> 
                        {
                            invalid ?              
                                <LiveMessage message= { 'Prior field error: ' + invalidText } aria-live="assertive"/>  
                            :
                            null
                        }           
                    </LiveAnnouncer>    
                </div>
            )}
        </>
    )
}

FormInput.propTypes = {
    visible: PropTypes.bool,
    type: PropTypes.string,
    labelText: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    autoComplete: PropTypes.string, 
    invalidText: PropTypes.string, 
    invalid: PropTypes.bool, 
    maxLength: PropTypes.number, 
    tabIndex: PropTypes.number, 
    value: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onChange: PropTypes.func,
    onPaste: PropTypes.func,
    onCopy: PropTypes.func,
    ariaLabel: PropTypes.string, 
    inputType: PropTypes.string,
    checked: PropTypes.bool,
    checkboxLabelText: PropTypes.element,
    inputWrapperClassName: PropTypes.string,
 }